// Navigation interne des écrans du conseil (lot L5-B, M16) : sessions, élus et règles.
import { Lien } from '@cc/ui';
import styles from '../achats/achats.module.css';

const ENTREES = [
  { id: 'sessions', libelle: 'Sessions', href: '/conseil' },
  { id: 'elus', libelle: 'Élus et règles', href: '/conseil/elus' },
] as const;

export function NavigationConseil({ actif }: { actif: (typeof ENTREES)[number]['id'] }) {
  return (
    <nav className={styles.navigation} aria-label="Conseil">
      {ENTREES.map((e) => (
        <Lien key={e.id} href={e.href} aria-current={e.id === actif ? 'page' : undefined} className={e.id === actif ? styles.lienActif : styles.lien}>
          {e.libelle}
        </Lien>
      ))}
    </nav>
  );
}
